// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// components
import {
    IconBlockSite,
} from 'components'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    TemplateBlock797DateTimeSite,
    TemplateBlock797TextAreaSite,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
} from 'serializers/site'

// props
type TemplateBlock797MultiDateFormModalSiteProps = {
    multiDateData: {
        fid: number
        description?: string
        start_date?: string
        end_date?: string
    }[]
    setMultiDateData: React.Dispatch<React.SetStateAction<{
        fid: number
        description?: string
        start_date?: string
        end_date?: string
    }[]>>
    defaultFields?: any
    objectId: number
    onCloseHelperModal: () => void
    onChange: any
    stylesNew: CustomCSSProperties | undefined
    setDateId: any
}

// main
export const TemplateBlock797MultiDateFormModalSite: React.FC<TemplateBlock797MultiDateFormModalSiteProps> = React.memo(({
    setMultiDateData,
    multiDateData,
    defaultFields,
    objectId,
    onCloseHelperModal,
    onChange,
    stylesNew,
    setDateId,
}) => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deviceType = reduxModalSite.deviceType

    type contactErrorsType = {
        description?: string
        end_date?: string
        start_date?: string
        main_error?: string
        non_field_errors?: string
    }

    type contactFieldsType = {
        description?: string
        end_date?: string
        start_date?: string
    }

    const contactErrorsInitial = {
        description: '',
        end_date: '',
        start_date: '',
        main_error: '',
        non_field_errors: '',
    }

    const contactFieldsInitial = {
        description: '',
        end_date: '',
        start_date: '',
    }

    const [errors, setErrors] = useState<contactErrorsType>(contactErrorsInitial)
    const [fields, setFields] = useState<contactFieldsType>(contactFieldsInitial)

    useEffect(() => {
        // @ts-ignore
        if (objectId && objectId !== 'new') {
            setFields(multiDateData.find((item) => item.fid === objectId) || contactFieldsInitial)
        }
    }, [
        objectId,
    ])

    function handleInputChange(name: string, value: any, label: string, stripe_field_type: string | undefined, stringValue?: string) {
        try {
            // setButtonDisabled(false)
            setFields({
                ...fields,
                [name]: value,
            })
            setErrors({})
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock797MultiDateFormModalSite',
                'handleInputChange',
            ))
        }
    }

    function handleRequired() {
        try {
            let result: any = 'ok'
            if (!fields.start_date) {
                result = {
                    start_date: reduxText[7489], // Required field missing
                }
            }
            if (fields.end_date && fields.start_date) {
                const startDate = new Date(fields.start_date)
                const endDate = new Date(fields.end_date)
                if (endDate < startDate) {
                    result = {
                        end_date: 'La date de fin doit être postérieure à la date de début.', // The end date must be after the start date.
                    }
                }
            }
            if (result === 'ok') {
                handleSubmit()
            } else {
                // setHelpers({
                //     ...helpers,
                //     mainError: reduxText[4798],
                // })
                setErrors(result)
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock797MultiDateFormModalSite',
                'handleRequired',
            ))
        }
    }

    function handleSubmit() {
        try {
            const mulidateFields = [
                'description',
                'end_date',
                'start_date',
            ]
            const jsonObject: any = {}
            Object.entries(fields).forEach(([key, value]) => {
                if (
                    mulidateFields.includes(key) &&
                    value !== undefined &&
                    value !== null &&
                    value !== ''
                ) {
                    if (jsonObject.hasOwnProperty(key)) {
                        if (Array.isArray(jsonObject[key])) {
                            jsonObject[key].push(value)
                        } else {
                            jsonObject[key] = [jsonObject[key], value]
                        }
                    } else {
                        jsonObject[key] = value
                    }
                }
            })
            setMultiDateData(prev => {
                const newItem = {
                    fid: Math.floor(Math.random() * 1000000000),
                    description: jsonObject.description || '',
                    start_date: jsonObject.start_date,
                    end_date: jsonObject.end_date,
                }
                const newArray = [...prev, newItem]
                onChange(newArray)
                return newArray
            })
            onCloseHelperModal()
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock797MultiDateFormModalSite',
                'handleSubmit',
            ))
        }
    }

    return (
        <Dialog
            className='template-block-797-multi-date-form-modal'
            classes={{ paper: 'mo-dialog-wrapper' }}
            disableEnforceFocus
            maxWidth='xl'
            onClose={() => setDateId(false)}
            open
        >
            <DialogTitle className='mo-dialog-header'>
                <div className='mo-dialog-header-close-wrap'>
                    <IconBlockSite
                        className='mo-dialog-header-close'
                        iconClass='mo-new-icon-times-solid'
                        onClick={onCloseHelperModal}
                    />
                </div>
            </DialogTitle>
            <DialogContent className={`mo-dialog-content mo-hidden-vertical-scrollbar${reduxModalSite.isWindows}`}>
                <div
                    className={`template-block-79$6 ${deviceType}`}
                    style={{
                        padding: '0px 0px 20px',
                    }}
                >
                    <span
                        className={`template-block-779 ${deviceType}`}
                        style={{
                            color: 'rgb(18, 53, 106)',
                            fontFamily: 'Open Sans',
                            fontSize: '14px',
                            letterSpacing: '0.3px',
                            lineHeight: 1.5,
                            padding: '0px 0px 5px',
                        }}
                    >
                        Date et heure de début
                    </span>
                    <TemplateBlock797DateTimeSite
                        blockId={'0'}
                        deviceType={deviceType}
                        formInputObj={{
                            data_json: {
                                min_date_today: true,
                                time_intervals: 15,
                            },
                            field_type: 'datetime',
                            label: 'Date et heure de début',
                            name: 'start_date',
                        }}
                        format='datetime'
                        handleInputChange={handleInputChange}
                        isEditHovered={false}
                        reduxModalSite={reduxModalSite}
                        stylesNew={stylesNew}
                        tabIndex={0}
                        value={fields.start_date || ''}
                    />
                    {errors.start_date && (
                        <span
                            className='t-797-error'
                            style={{
                                fontFamily: stylesNew?.fontFamily,
                            }}
                        >
                            {errors.start_date}
                        </span>
                    )}
                </div>
                <div
                    className={`template-block-79$6 ${deviceType}`}
                    style={{
                        padding: '0px 0px 20px',
                    }}
                >
                    <span
                        className={`template-block-779 ${deviceType}`}
                        style={{
                            color: 'rgb(18, 53, 106)',
                            fontFamily: 'Open Sans',
                            fontSize: '14px',
                            letterSpacing: '0.3px',
                            lineHeight: 1.5,
                            padding: '0px 0px 5px',
                        }}
                    >
                        Date et heure de début
                    </span>
                    <TemplateBlock797DateTimeSite
                        blockId={'1'}
                        deviceType={deviceType}
                        formInputObj={{
                            data_json: {
                                min_date_today: true,
                                time_intervals: 15,
                            },
                            field_type: 'datetime',
                            label: 'Date et heure de fin',
                            name: 'end_date',
                        }}
                        format='datetime'
                        handleInputChange={handleInputChange}
                        isEditHovered={false}
                        reduxModalSite={reduxModalSite}
                        stylesNew={stylesNew}
                        tabIndex={1}
                        value={fields.end_date || ''}
                    />
                    {errors.end_date && (
                        <span
                            className='t-797-error'
                            style={{
                                fontFamily: stylesNew?.fontFamily,
                            }}
                        >
                            {errors.end_date}
                        </span>
                    )}
                </div>
                <div
                    className={`template-block-79$6 ${deviceType}`}
                    style={{
                        padding: '0px 0px 20px',
                    }}
                >
                    <span
                        className={`template-block-779 ${deviceType}`}
                        style={{
                            color: 'rgb(18, 53, 106)',
                            fontFamily: 'Open Sans',
                            fontSize: '14px',
                            letterSpacing: '0.3px',
                            lineHeight: 1.5,
                            padding: '0px 0px 5px',
                        }}
                    >
                        Quelques détails sur l’activité (facultatif)
                    </span>
                    <TemplateBlock797TextAreaSite
                        blockId={'2'}
                        deviceType={deviceType}
                        formInputObj={{
                            label: 'Quelques détails sur l’activité (facultatif)',
                            name: 'description',
                        }}
                        handleInputChange={handleInputChange}
                        isEditHovered={false}
                        reduxModalSite={reduxModalSite}
                        stylesNew={stylesNew}
                        tabIndex={2}
                        value={fields.description || ''}
                    />
                    {errors.description && (
                        <span
                            className='t-797-error'
                            style={{
                                fontFamily: stylesNew?.fontFamily,
                            }}
                        >
                            {errors.description}
                        </span>
                    )}
                </div>
            </DialogContent>
            <DialogActions className='mo-dialog-footer'>
                <div
                    className={`template-block-783 ${deviceType}`}
                    onClick={handleRequired}
                    style={{
                        background: 'rgb(18, 53, 106)',
                        borderColor: 'rgb(18, 53, 106)',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        color: 'rgb(255, 255, 255)',
                        fontSize: '14px',
                        letterSpacing: '0.3px',
                        padding: '10px',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        width: '100%',
                        cursor: 'pointer'
                    }}
                >
                    Ajouter
                </div>
            </DialogActions>
        </Dialog>
    )

})
